import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST ALL showcaseS
export const showcaseList = (params = '') => Http.get(`/showcases${serialize(params)}`)
export const showcaseCreate = (params = '') => Http.post('/showcases', params)
export const showcaseByID = (params = '') => Http.get(`/showcases/${params}`)
export const showcaseUpdate = (params = '') => Http.put(`/showcases/${params.id}`, params)
export const showcaseSetCurrent = id => Http.put(`/showcases/${id}/set-current`)
export const showcaseToggleMediaPartnerApplications = (id, value) => Http.put(`/showcases/${id}/toggle-media-partner-applications`, { media_partner_applications_open: value })
export const showcaseDestroy = (params = '') => Http.delete(`/showcases/${params.id}`)
